import { c as _c } from "react/compiler-runtime";
import { Typography } from '@mui/material';
import type { PropsWithChildren } from 'react';
export function SectionName(t0) {
  const $ = _c(4);
  const {
    children,
    bold
  } = t0;
  const t1 = bold ? "textBold" : "text";
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      fontSize: "14px"
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== children || $[2] !== t1) {
    t3 = <Typography variant={t1} sx={t2}>{children}</Typography>;
    $[1] = children;
    $[2] = t1;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}